import React, { PropsWithChildren } from 'react';

type Props = {
  fullOnMobile?: boolean;
  style?: React.CSSProperties;
  innerStyle?: React.CSSProperties;
  className?: string;
};
export const Container: React.FC<PropsWithChildren<Props>> = (props) => {
  const { className, children, fullOnMobile = false, style = {}, innerStyle = {} } = props;
  return (
    <div className={className} style={style}>
      <div className={`container ${fullOnMobile ? 'full-on-mobile' : ''}`} style={innerStyle}>
        {children}
      </div>
    </div>
  );
};
